import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {LovListModel} from "../../../api/model/lovList.model";
import {AbstractService} from "../../../../../../core/service/abstractService";

@Injectable()
export class LovListService extends AbstractService<LovListModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('LovList', serviceElementsFactory, injector);
    }

}
